<template>
	<div class="page" v-loading="loading">
		<el-breadcrumb>
			<el-breadcrumb-item>订单管理</el-breadcrumb-item>
			<el-breadcrumb-item>所有订单</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" class="top">
			<el-form-item>
				<el-input v-model="filter.order_no" placeholder="搜索订单号" size="mini" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-select v-model="filter.status" placeholder="请选择订单状态" value-key="label" size="mini" clearable
					style="width: 170px;">
					<el-option label="待付款" :value="1"></el-option>
					<el-option label="已付款" :value="2"></el-option>
					<el-option label="已开卡" :value="3"></el-option>
					<el-option label="已发货" :value="4"></el-option>
					<el-option label="已完成" :value="5"></el-option>
					<el-option label="退款中" :value="6"></el-option>
					<el-option label="已退款" :value="7"></el-option>
					<el-option label="已取消" :value="8"></el-option>
					<el-option label="团单" :value="10"></el-option>
					<el-option label="付定单" :value="12"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-date-picker v-model="date" type="daterange" range-separator="——" start-placeholder="开始日期"
					end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" size="mini" style="width: 260px;"
					@change="change">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="mini" @click="toSearch">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="success" size="mini" @click="refresh">刷新</el-button>
			</el-form-item>
		</el-form>

		<el-table :data="tableData" :header-cell-style="{background:'#F5F5F5'}" size="mini"
			style="width: 100%; margin-bottom: 20px;" stripe border :cell-style="changeCellStyle">
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column prop="store" label="商品来源">
				<template slot-scope="scope">
					{{ scope.row.store ? scope.row.store : '' }}
				</template>
			</el-table-column>
			<el-table-column label="商品信息" width="350">
				<template slot-scope="scope">
					<div class="flex">
						<div class="imgbox">
							<img :src="scope.row.thumb" />
						</div>
						<div class="titlebox">
							<p>【{{ scope.row.code }}】</p>
							<p class="title">{{ scope.row.title }}</p>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="payment" label="单价">
				<template slot-scope="scope">
					{{ scope.row.payment }}
				</template>
			</el-table-column>
			<el-table-column prop="num" label="数量">
				<template slot-scope="scope">
					{{ scope.row.num }}
				</template>
			</el-table-column>
			<el-table-column prop="total" label="总价">
				<template slot-scope="scope">
					{{ scope.row.total }}
				</template>
			</el-table-column>
			<el-table-column prop="nickname" label="客户信息">
				<template slot-scope="scope">
					<p>
						<i class="el-icon-user"></i>
						<span style="margin-left: 5px;">{{ scope.row.member.nickname }}</span>
					</p>
				</template>
			</el-table-column>
			<el-table-column label="订单信息" width="260">
				<template slot-scope="scope">
					<p class="orderinfo">订单号：{{ scope.row.order_no }}</p>
					<p class="orderinfo">下单时间：{{ scope.row.created_at }}</p>
					<p class="orderinfo">付款时间：{{ scope.row.payed_at }}</p>
				</template>
			</el-table-column>
			<el-table-column prop="commission" label="代理佣金">
				<template slot-scope="scope">
					{{ scope.row.commission }}
				</template>
			</el-table-column>
			<el-table-column prop="status" label="订单状态">
				<template slot-scope="scope">
					<p style="color: #007CFF;">
						{{ scope.row.status == 0 ? '待付款' : scope.row.status == 1 ? '已付款' : scope.row.status == 2 ? '已开卡' : scope.row.status == 3 ? '已发货' : 
						scope.row.status == 4 ? '已完成' : scope.row.status == 5 ? '退款中' : scope.row.status == 6 ? '已退款' : scope.row.status == 7 ? '已取消' : 
						scope.row.status == 9 ? '团单' : scope.row.status == 11 ? '付定金' : '' }}
					</p>
				</template>
			</el-table-column>
			<div slot="append">
				<div ref='huizong' style="display: flex;">
					<div class='sum' style="width: 925px;">预估佣金汇总</div>
					<div class='sum'>{{ commission_sum }}</div>
				</div>
			</div>
		</el-table>

		<el-pagination background layout="prev,pager,next,total" :page-count="maxpage" :total="total" :page-size="15"
			@current-change="pageChange"></el-pagination>
	</div>
</template>

<script>
	export default {
		name: 'OrderAll',
		data() {
			return {
				loading: false,
				tableData: [],
				page: 1,
				maxpage: 1,
				total: 0,
				date: '',
				filter: {
					page: '',
					order_no: '',
					start_time: '',
					end_time: '',
					status: '',
				},
				commission_sum: '',
			}
		},
		methods: {
			getData() {
				this.tableData = []
				this.loading = true
				this.filter = {
					page: this.page,
					status: this.filter.status,
					order_no: this.filter.order_no,
					start_time: this.filter.start_time,
					end_time: this.filter.end_time,
				}
				this.$util.get('agent/getOrder', this.filter)
					.then(res => {
						console.log(res.data)
						this.tableData = res.data
						this.total = res.total
						this.maxpage = res.last_page
						this.loading = false
						if (res.data && res.data.length > 0) {
							for (let i = 0; i < this.total; i++) {
								var name, name1
								for (let j = 0; j < this.tableData[i].member.nickname.length; j++) {
									if (j == 0) {
										name = this.tableData[i].member.nickname[j]
									} else {
										name1 = this.tableData[i].member.nickname.substr(j, 1)
										name1 = "*"
										name = name + name1
									}
								}
								this.tableData[i].member.nickname = name
							}
						}
						if (this.tableData[0].commission_sum) {
							this.commission_sum = this.tableData[0].commission_sum
						} else {
							this.commission_sum = ''
						}
					})
			},
			pageChange(page) {
				this.tableData = []
				this.page = page
				this.getData()
			},
			toSearch() {
				this.page = 1
				this.maxpage = 1
				this.total = 0
				this.tableData = []
				this.getData()
			},
			refresh() {
				this.getData()
			},
			change(value) {
				if (value) {
					this.filter.start_time = value[0]
					this.filter.end_time = value[1]
				} else {
					this.filter.start_time = ''
					this.filter.end_time = ''
				}
			},
			changeCellStyle(row) {
				if (row.column.label == '订单信息') {
					return "text-align: left;"
				} else {
					return "text-align: center;"
				}
			},
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped>
	.el-table {
		margin-top: 30px;
	}

	.el-table /deep/ .has-gutter .cell {
		text-align: center;
	}

	.top {
		margin-top: 30px;
	}

	.flex {
		display: flex;
	}

	.titlebox {
		width: 200px;
		text-align: left;
	}

	.title {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.imgbox {
		width: 100px;
		height: 100px;
		margin-right: 10px;
	}

	.imgbox img {
		width: 100%;
		height: 100%;
	}

	.sum {
		box-sizing: border-box;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		word-break: break-all;
		line-height: 30px;
		padding-right: 10px;
		width: 50%;
		font-size: 4px;
		text-align: center;
		border-right: 1px solid #EBEEF5;
	}
</style>
